import ErrorPage from "components/common/ErrorPage";
import Login from "components/features/Login";
import { useState } from "react";
import { browserName, osName } from "react-device-detect";
import { ErrorBoundary } from "react-error-boundary";
import secureLocalStorage from "react-secure-storage";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { errorLogs } from "./App.slice";
import Main from "./Main";

function App() {
  const userDetails = secureLocalStorage.getItem("un");
  const dispatch = useAppDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(!!userDetails);
  const loggedInUserInfo = useAppSelector((state) => state.app.userName);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const impersonationDetails = useAppSelector((state: any) => state.app.impersonationDetails);
  const loggedInUserDetails = useAppSelector((state) => state.app.loggedInUserDetails);
  const userSelectedInnCode = useAppSelector((state: any) => state.app.innCode);

  const logErrorToFile = (componentName: string, errorMessage: string, error: any) => {
    const pathWithQuery = window.location.pathname + window.location.search;
    const data = {
      message: errorMessage,
      error: error.stack,
      component: componentName,
      route: pathWithQuery,
      hltId: loggedInUserInfo?.hltId,
      lobbyUserType: loggedInUserInfo?.lobbyUserType,
      displayName: loggedInUserInfo?.displayName,
      isImpersonated,
      date: Date(),
      browser: browserName,
      device: osName,
      impersonatedUserDetails: isImpersonated ? impersonationDetails : {},
      isConsultant: loggedInUserDetails.isConsultant,
      selectedInncode: userSelectedInnCode
    };
    dispatch(errorLogs(data));
  };

  const extractComponentName = (stack: string): { componentName: string } => {
    const match = stack.match(/at (\w+)/);
    return {
      componentName: match ? match[1] : "UnknownComponent.js"
    };
  };

  return (
    <ErrorBoundary
      fallback={<ErrorPage />}
      onError={(error: any, errorInfo: { componentStack: string }) => {
        const { componentName } = extractComponentName(errorInfo.componentStack);
        logErrorToFile(componentName, error.message, error);
      }}
    >
      {isLoggedIn ? <Main /> : <Login isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />}
    </ErrorBoundary>
  );
}

export default App;
